import React, { Component } from 'react';

import './styles.css';

class TextAction extends Component {
  render() {
    const { className, children, ...props } = this.props;
    return (
      <button className={`TextAction ${className || ''}`} {...props}>
        {children}
      </button>
    );
  }
}

export default TextAction;
